<template>
  <div class="quiz-intro__options">
    <div class="questions">
      <custom-button
        v-for="(item, index) in items"
        :key="`option-${index}`"
        :caption="item.text"
        :class="{ selected: item.id === selected }"
        @clicked="() => selectQuestion(item.id, item.nextGroupID)"
      ></custom-button>
    </div>

    <questions-nav
      @next="
        step(() => selected >= 0 && $emit('next', selected, selectedNextGroup))
      "
      @back="backStep(() => $emit('back'))"
      :showN="selectedId > -1"
      :next="next"
      :previous="previous"
    />
  </div>
</template>
<script>
import Button from "../components/Button.vue";
import QuestionsNav from "../components/QuestionsNav.vue";

export default {
  name: "OptionsQuestion",
  components: {
    CustomButton: Button,
    QuestionsNav
  },
  data: function() {
    return {
      selected: -1,
      selectedNextGroup: -1
    };
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    selectedId: {
      type: Number,
      default: -1
    },
    previous: String,
    next: String
  },
  watch: {
    selectedId: function(val, oldVal) {
      this.selected = val;
    }
  },
  methods: {
    selectQuestion: function(index, nextId) {
      this.$emit("next", index, nextId);
    },
    step: function(callback) {
      callback();
      this.selected = -1;
    },
    backStep: function(callback) {
      callback();
      this.selected = this.selectedId;
    }
  },
  mounted: function() {
    this.selected = this.selectedId;
  },
  activated: function() {
    this.selected = this.selectedId;
  }
};
</script>